// The "Kaj je novega" popup. Edit the texts here; change VERSION when there is something new to show
// again (the popup is shown once per visitor per version).
export const WHATS_NEW_VERSION = "2026-10";

export const WHATS_NEW_TITLE = "Kaj je novega";

export const WHATS_NEW_ITEMS = [
  {
    title: "Zahvale in spomini",
    text: "Na spominski strani lahko objavite zahvalo ali spomin ob obletnici; prikaže se tudi na prvi strani.",
  },
  {
    title: "Spominska svečka",
    text: "Animirana svečka z vašim imenom gori eno ali pet let in obstoječemu Skrbniku hkrati podaljša status.",
  },
  {
    title: "Skrbnik",
    text: "Postanite Skrbnik za 10 dni, eno leto ali pet let in povabite še drugega Skrbnika.",
  },
  {
    title: "Poudarjena osmrtnica",
    text: "Osmrtnica z obarvanim ozadjem je do pogreba vedno na vrhu seznama.",
  },
  {
    title: "Obvestila",
    text: "Pred obletnicami bližnjih in ob koncu statusa Skrbnika vam pošljemo opomnik. Vklopite jih v uporabniškem računu.",
  },
];
